<div class="seller-page">

  <div class="buttons-section">
    <h1>Mon Parc propriétaire ({{(myCars$ | async)?.length}})</h1>
    <button mat-button (click)="openCarEditDialog()" class="cta-button-buy"><mat-icon>add</mat-icon>Ajouter un véhicule</button>
  </div>

  @if (((myCars$ | async) == undefined ) || (myCars$ | async)!.length === 0 ) {
    <h6>
      <br />
      Aucun véhicule dans votre parc
    </h6>
  }

  @if ((((myCars$ | async) != undefined ) && (myCars$ | async)!.length > 0)) {
    <div class="cars-section">
      @for (car of (myCars$ | async)!; track car; let i = $index) {
        <div id="{{car.carId}}" class="car-section">
          <app-car-card-seller
            [car]="car"
            [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!"
            [currentDealer]="currentSeller" >
          </app-car-card-seller>
        </div>
      }
    </div>
  }

</div>





